import Typograf from 'typograf';

const typograf = new Typograf({ locale: ['ru', 'en-US'] });

typograf.disableRule('common/space/trimLeft');
typograf.disableRule('common/space/trimRight');
typograf.disableRule('common/number/times');
typograf.disableRule('common/space/afterColon');
typograf.disableRule('common/punctuation/quote');
typograf.setSetting('common/nbsp/afterShortWord', 'lengthShortWord', 3);

const DEFAULT_REL = 'nofollow';
const INTERNAL_DOMAIN = 'doxa.team';

function isInternalLink(href) {
  if (!href) return false;

  try {
    const url = new URL(href, `https://${INTERNAL_DOMAIN}`); // base для относительных ссылок
    return (
      url.hostname === INTERNAL_DOMAIN ||
      url.hostname.endsWith(`.${INTERNAL_DOMAIN}`)
    );
  } catch {
    return false;
  }
}

export function processTextContent(content) {
  return content.map((block) => {
    // eslint-disable-next-line no-underscore-dangle
    if (block._type !== 'block') return block;

    const processedChildren = block.children.map((child) => {
      const processedText = typograf.execute(child.text);
      return { ...child, text: processedText };
    });

    const processedMarkDefs = (block.markDefs || []).map((markDefinition) => {
      // eslint-disable-next-line no-underscore-dangle
      if (markDefinition._type !== 'link') return markDefinition;

      if (isInternalLink(markDefinition.href)) return markDefinition;

      return {
        ...markDefinition,
        rel: DEFAULT_REL,
      };
    });

    return {
      ...block,
      children: processedChildren,
      markDefs: processedMarkDefs,
    };
  });
}
